const KeyCodeConstants = {
  RIGHT_ARROW: 26,
  LEFT_ARROW: 27,
  DOWN_ARROW: 40,
  UP_ARROW: 38,
  ENTER: 13,
  TAB: 9,
  SPACE: 32,
};

export default KeyCodeConstants;
